import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'

interface HeroCTAProps {
  fullWidth?: boolean
  headline: string
}

export const HeroCTA = ({ fullWidth = false, headline }: HeroCTAProps) => (
  <>
    <div className='d-block d-lg-none'>
      <div className='row justify-content-center mc-text--center align-items-start'>
        <div className='col-12' style={{ maxWidth: '400px' }}>
          <div className='mc-mb-3'>
            <CTA
              fullWidth={fullWidth}
              style={{ maxWidth: '380px' }}
              className='mc-px-9'
              trackProps={{
                category: headline,
                content_type: 'product',
                location: 'hero',
              }}
            />
          </div>
        </div>
        <div className='mc-mt-1 col-9'>
          <p className='mc-text-small'>
            <PricingText translationKey='long' className='mc-opacity--hinted' />
          </p>
        </div>
      </div>
    </div>
    <div className='d-none d-lg-block'>
      <div className='row justify-content-start mc-text--left align-items-start'>
        <div className='col-auto'>
          <CTA
            fullWidth
            className='mc-mb-3 mc-px-9'
            trackProps={{
              category: headline,
              content_type: 'product',
              location: 'hero',
            }}
          />
        </div>
        <PricingText
          translationKey='long'
          className='col-5 mc-text-small mc-opacity--hinted'
        />
      </div>
    </div>
  </>
)
